import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const cards = [
  {
    icon: "ri-team-line",
    title: "Équipes et squads",
    description: "Rejoignez ou créez votre squad de 4 membres. Entraînez-vous ensemble, relevez des défis et progressez en équipe.",
    link: "/communaute/squads",
  },
  {
    icon: "ri-trophy-line",
    title: "Défis sportifs",
    description: "Participez à nos challenges mensuels, tournois internes et compétitions inter-entreprises. Dépassez vos limites !",
    link: "/sport/evenements",
  },
  {
    icon: "ri-bar-chart-line",
    title: "Suivi des performances",
    description: "Consultez vos statistiques, résultats et classements dans votre espace membre personnalisé.",
    link: "/membre",
  },
  {
    icon: "ri-newspaper-line",
    title: "Fil d'Actualités",
    description: "Restez informé des dernières nouvelles du club, des résultats de matchs et des annonces importantes.",
    link: "/actualites",
  },
];

export default function PresentationSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="inline-block px-4 py-1.5 rounded-full bg-orange-50 text-[#E8521A] text-sm font-medium mb-4">
            Notre Communauté
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-4">
            Votre Communauté Sportive
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Découvrez tout ce que l'ASC Sonatel vous offre pour une vie sportive et culturelle épanouie
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {cards.map((card, i) => (
            <Link
              key={i}
              to={card.link}
              className={`group flex h-full flex-col rounded-[30px] border border-[#d7d7d7] bg-white p-7 shadow-[0_10px_30px_rgba(15,23,42,0.05)] hover:-translate-y-1 hover:shadow-[0_14px_36px_rgba(15,23,42,0.09)] transition-all duration-300 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl border border-[#ececec] bg-[#f4f4f4] text-[#5c5c5c]">
                <i className={`${card.icon} text-[28px]`}></i>
              </div>
              <h3 className="mb-3 text-[1.7rem] font-bold leading-tight text-[#1A1A1A] group-hover:text-[#E8521A] transition-colors">
                {card.title}
              </h3>
              <p className="mb-6 text-base leading-8 text-[#666666]">{card.description}</p>
              <span className="mt-auto inline-flex items-center gap-1 text-base font-semibold text-[#E8521A] transition-all group-hover:gap-2">
                En savoir plus
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
